var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c("div", [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "d-block" }, [
            _vm.picture
              ? _c("img", {
                  staticClass: "img img-fluid image-preview",
                  attrs: { src: _vm.picture },
                })
              : _vm._e(),
          ]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "file", accept: "image/*", disabled: _vm.disabled },
            on: { change: _vm.uploadImage },
          }),
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _vm._m(2),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.campaign.custom_headline_text,
                  expression: "campaign.custom_headline_text",
                },
              ],
              ref: "custom_headline_text",
              staticClass: "form-control",
              attrs: { type: "text", disabled: _vm.disabled },
              domProps: { value: _vm.campaign.custom_headline_text },
              on: {
                change: function ($event) {
                  return _vm.update("custom_headline_text")
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.campaign,
                    "custom_headline_text",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _c("div", { staticClass: "form-group col-md-12" }, [
            _vm._m(3),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-group col-md-8" }, [
                _c("label", { staticClass: "d-inline mx-10" }, [
                  _vm._v("#1 Date Time"),
                ]),
                _c(
                  "div",
                  { staticClass: "d-inline mx-10" },
                  [
                    _c("DatePicker", {
                      attrs: {
                        type: "datetime",
                        placeholder: "n/a",
                        disabled: !_vm.canEditExpiration,
                        "disabled-date": _vm.disabledBetweenStartEnd,
                        format: "YYYY-MM-DD HH:mm:ss",
                        "value-type": "format",
                        "show-time-panel":
                          _vm.showTimePanelexpiration_reminders1,
                        confirm: true,
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders1")
                        },
                        clear: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders1")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "mx-btn mx-btn-text",
                                    on: {
                                      click: function ($event) {
                                        _vm.showTimePanelexpiration_reminders1 =
                                          !_vm.showTimePanelexpiration_reminders1
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showTimePanelexpiration_reminders1
                                            ? "select date"
                                            : "select time"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3793124778
                      ),
                      model: {
                        value: _vm.campaign.expiration_reminders1,
                        callback: function ($$v) {
                          _vm.$set(_vm.campaign, "expiration_reminders1", $$v)
                        },
                        expression: "campaign.expiration_reminders1",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "form-group col-md-8" }, [
                _c("label", { staticClass: "d-inline mx-10" }, [
                  _vm._v("#2 Date Time"),
                ]),
                _c(
                  "div",
                  { staticClass: "d-inline mx-10" },
                  [
                    _c("DatePicker", {
                      attrs: {
                        type: "datetime",
                        placeholder: "n/a",
                        disabled: !_vm.canEditExpiration,
                        "disabled-date": _vm.disabledBetweenStartEnd,
                        format: "YYYY-MM-DD HH:mm:ss",
                        "value-type": "format",
                        "show-time-panel":
                          _vm.showTimePanelexpiration_reminders2,
                        confirm: true,
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders2")
                        },
                        clear: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders2")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "mx-btn mx-btn-text",
                                    on: {
                                      click: function ($event) {
                                        _vm.showTimePanelexpiration_reminders2 =
                                          !_vm.showTimePanelexpiration_reminders2
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showTimePanelexpiration_reminders2
                                            ? "select date"
                                            : "select time"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4019599049
                      ),
                      model: {
                        value: _vm.campaign.expiration_reminders2,
                        callback: function ($$v) {
                          _vm.$set(_vm.campaign, "expiration_reminders2", $$v)
                        },
                        expression: "campaign.expiration_reminders2",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "form-group col-md-8" }, [
                _c("label", { staticClass: "d-inline mx-10" }, [
                  _vm._v("#3 Date Time"),
                ]),
                _c(
                  "div",
                  { staticClass: "d-inline mx-10" },
                  [
                    _c("DatePicker", {
                      attrs: {
                        type: "datetime",
                        placeholder: "n/a",
                        disabled: !_vm.canEditExpiration,
                        "disabled-date": _vm.disabledBetweenStartEnd,
                        format: "YYYY-MM-DD HH:mm:ss",
                        "value-type": "format",
                        "show-time-panel":
                          _vm.showTimePanelexpiration_reminders3,
                        confirm: true,
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders3")
                        },
                        clear: function ($event) {
                          return _vm.handleOpenChange("expiration_reminders3")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "mx-btn mx-btn-text",
                                    on: {
                                      click: function ($event) {
                                        _vm.showTimePanelexpiration_reminders3 =
                                          !_vm.showTimePanelexpiration_reminders3
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showTimePanelexpiration_reminders3
                                            ? "select date"
                                            : "select time"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        68343912
                      ),
                      model: {
                        value: _vm.campaign.expiration_reminders3,
                        callback: function ($$v) {
                          _vm.$set(_vm.campaign, "expiration_reminders3", $$v)
                        },
                        expression: "campaign.expiration_reminders3",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "form-control-label" }, [
        _c("h4", [_vm._v("LINE Notification")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "d-inline mx-10 form-control-label" }, [
        _vm._v(
          " Announcement picture (recommended size 1000x560/less than 1 MB) "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("h5", [_vm._v("Custom headline text (announcement)")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("h5", [_vm._v("Expiration Reminders")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }